export default __webpack_public_path__ + "static/media/booked.c57ecc4d.png";